
/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';
import { createOpenModalAction } from 'state/ui/actions';
import { isModalVisible } from 'state/ui/selectors';


const openModal = createOpenModalAction('SyncResourceConnectModal');

export const startSyncResourceConnectModal = (resourceConnectId) => dispatch => {
    dispatch({
        type: actions.START_SYNC_RESOURCE_CONNECT_MODAL,
        payload: { resourceConnectId }
    })
    dispatch(openModal());
}